import React, { useEffect, useState } from 'react'
import emailjs from '@emailjs/browser'

const ContactUs = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [subject, setSubject] = useState('')

  const [sent, setSent] = useState(false)

  const [Enter, setEnter] = useState(false)

  const [validName, setValidName] = useState(true)
  const [validEmail, setValidEmail] = useState(true)
  const [validMessage, setValidMessage] = useState(true)
  const [validSubject, setValidSubject] = useState(true)

  useEffect(() => {
    if (validEmail && validMessage && validName && validSubject) {
      SendEmail()
    }
    //eslint-disable-next-line
  }, [validEmail, validName, validMessage, Enter, validSubject])

  useEffect(() => {
    setTimeout(() => {
      if (sent) {
        setSent(false)
      }
    }, 1000)
  }, [sent])

  const handleApply = (e) => {
    setValidName(false)
    const emailRegex = /\S+@\S+\.\S+/
    if (name.length < 2) {
      setValidName(false)
    } else {
      setValidName(true)
    }

    if (emailRegex.test(email)) {
      setValidEmail(true)
    } else {
      setValidEmail(false)
    }

    if (message.length < 10 || message.length > 150) {
      setValidMessage(false)
    } else {
      setValidMessage(true)
    }
    if (subject.length < 1 || message.length > 300) {
      setValidSubject(false)
    } else {
      setValidSubject(true)
    }

    setSent(false)
    setEnter(!Enter)
  }

  const SendEmail = () => {
    if (name.length === 0 && email.length === 0 && message.length === 0 && subject.length === 0) {
      setValidEmail(true)
      setValidMessage(true)
      setValidName(true)
      setValidSubject(true)
      return
    }
    const value = {
      name: name,
      email: email,
      message: message,
      subject: subject,
    }
    setName('')
    setEmail('')
    setMessage('')
    setSubject('')

    emailjs.send('service_2riiyyp', 'template_enncsum', value, '5AgxOxIqxk5lMtmL2').then(
      function (response) {
        console.log('SUCCESS!', response.status, response.text)
        setSent(true)
      },
      function (err) {
        console.log('FAILED...', err)
      }
    )
  }
  return (
    <div className='componentFirst contactUsScroll'>
      <div className='componentSecond'>
        <div className='mainContactUsFormPage'>
          <div className='formHeader'>
            <div className='formHeaderLeft'></div>
            <div className='formHeaderCenter'>Kontaktformular</div>
            <div className='formHeaderRight'></div>
          </div>
          <div className='mainContactUsFormInputHalf'>
            <div className='mainContactUsFormInput'>
              <div className='mainContactUsFormInputTitle'>
                {validName ? (
                  'Name*'
                ) : (
                  <>
                    Name* <span className='contactUsNotValidValue'> Name to short</span>
                  </>
                )}
              </div>
              <div className={validName ? 'mainContactUsFormInputBox' : 'mainContactUsFormInputBox contactBorder'}>
                <input
                  type='text'
                  placeholder='Name'
                  className='contactUsInput'
                  name='name'
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                />
              </div>
            </div>
            <div className='mainContactUsFormInput'>
              <div className='mainContactUsFormInputTitle'>
                {validEmail ? (
                  'E-Mail*'
                ) : (
                  <>
                    E-Mail*<span className='contactUsNotValidValue'> Wrong email address</span>
                  </>
                )}
              </div>
              <div
                className={validEmail ? 'mainContactUsFormInputBox' : 'mainContactUsFormInputBox contactBorder'}
              >
                <input
                  type='email'
                  placeholder='E-Mail'
                  className='contactUsInput'
                  name='email'
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
              </div>
            </div>
          </div>
          <div className='mainContactUsFormInput'>
            <div className='mainContactUsFormInputTitle'>
              {validSubject ? (
                'Betreff*'
              ) : (
                <>
                  Betreff*
                  <span className='contactUsNotValidValue'> The subject should be between 1 and 300 symbols</span>
                </>
              )}
            </div>
            <div
              className={validSubject ? 'mainContactUsFormInputBox' : 'mainContactUsFormInputBox contactBorder'}
            >
              <input
                type='text'
                placeholder='In welchen Bereichen kann ich dir helfen?'
                className='contactUsInput'
                name='subject'
                value={subject}
                onChange={(event) => setSubject(event.target.value)}
              />
            </div>
          </div>
          <div className='mainContactUsFormInput'>
            <div className='mainContactUsFormInputTitle'>
              {validMessage ? (
                'Nachricht*'
              ) : (
                <>
                  Nachricht*
                  <span className='contactUsNotValidValue'> The message should be between 10 and 150 symbols</span>
                </>
              )}
            </div>
            <div
              className={
                validMessage
                  ? 'mainContactUsFormInputBox mainMessage'
                  : 'mainContactUsFormInputBox mainMessage contactBorder'
              }
            >
              <textarea
                type='text'
                placeholder='Nachricht'
                className='contactUsInput'
                name='message'
                value={message}
                onChange={(event) => setMessage(event.target.value)}
              />
            </div>
          </div>
          <div className='contactUsButton'>
            <div className='contactUsButtonContainer' onClick={handleApply}>
              Nachricht senden
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactUs
